import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturedProducts from "./components/FeaturedProducts";
import CategoryPreview from "./components/CategoryPreview";
import ReviewSection from "./components/ReviewSection";
import BannerSection from "./components/BannerSection";
import KakaoSection from "./components/KakaoSection";
import ServiceAreaSection from "./components/ServiceAreaSection";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedProducts />
        <BannerSection />
        <KakaoSection />
        <CategoryPreview />
        <ServiceAreaSection />
        <ReviewSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
